export enum GameSceneLifeCyclePhase {
  Constructor,
  Init,
  Preload,
  Create,
  Created,
  Destroy,
  Shutdown,
}
